// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * User Detail Modal Styles
 * Clean, responsive styles matching UserEditModal layout
 */

/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header - Now using global styles from design-system.css */

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-btn:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modal Body - Now using global styles from design-system.css */

/* Form Sections */
.form-section {
  margin-bottom: 24px;
}

.form-section:last-of-type {
  margin-bottom: 0;
}

.form-section h3 {
  margin: 0 0 16px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}

/* Form Rows */
.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row:last-child {
  margin-bottom: 0;
}

/* Form Groups */
/* Form Groups - Now using global styles from design-system.css */

/* User Profile Section */
.user-profile-section {
  text-align: center;
  padding: 20px 24px;
  margin-bottom: 24px;
}

.user-name-only {
  margin: 0;
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
}

/* Status and Role Badges */
.status-badge,
.role-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.approved {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.status-badge.pending {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.status-badge.inactive {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

.role-badge.superuser {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.role-badge.staff {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.role-badge.user {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

/* Info Value */
.info-value {
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #333;
  min-height: 20px;
  display: flex;
  align-items: center;
}


/* Permissions Grid */
.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.permission-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  text-align: center;
  transition: all 0.2s ease;
}

.permission-item:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.permission-label {
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.permission-status {
  font-weight: 700;
  font-size: 1rem;
  padding: 4px 8px;
  border-radius: 6px;
  min-width: 60px;
}

.permission-status.yes {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.1);
}

.permission-status.no {
  color: #e53e3e;
  background: rgba(229, 62, 62, 0.1);
}

/* Modal Footer - Now using global styles from design-system.css */

/* Buttons - Now using global styles from design-system.css */

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

/* Responsive Design */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .form-row:first-child {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 20px;
  }

  .user-name-only {
    font-size: 1.6rem;
  }

  .permissions-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }

  .modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }

  .form-section {
    margin-bottom: 20px;
  }

  .user-profile-section {
    padding: 16px;
  }

  .user-name-only {
    font-size: 1.4rem;
  }

  .permissions-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .permission-item {
    padding: 16px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/users/UserDetailModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mEAAmE;;AAEnE,qEAAqE;;AAErE,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gEAAgE;;AAEhE,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB,iEAAiE;;AAEjE,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;;AAGA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,kEAAkE;;AAElE,6DAA6D;;AAE7D;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/**\n * User Detail Modal Styles\n * Clean, responsive styles matching UserEditModal layout\n */\n\n/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header - Now using global styles from design-system.css */\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover:not(:disabled) {\n  background: #e9ecef;\n  color: #333;\n}\n\n.close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Modal Body - Now using global styles from design-system.css */\n\n/* Form Sections */\n.form-section {\n  margin-bottom: 24px;\n}\n\n.form-section:last-of-type {\n  margin-bottom: 0;\n}\n\n.form-section h3 {\n  margin: 0 0 16px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n/* Form Rows */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Form Groups */\n/* Form Groups - Now using global styles from design-system.css */\n\n/* User Profile Section */\n.user-profile-section {\n  text-align: center;\n  padding: 20px 24px;\n  margin-bottom: 24px;\n}\n\n.user-name-only {\n  margin: 0;\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 1.2;\n  text-align: center;\n}\n\n/* Status and Role Badges */\n.status-badge,\n.role-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.approved {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n}\n\n.status-badge.pending {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.status-badge.inactive {\n  background: rgba(107, 114, 128, 0.1);\n  color: #6b7280;\n}\n\n.role-badge.superuser {\n  background: rgba(139, 92, 246, 0.1);\n  color: #8b5cf6;\n}\n\n.role-badge.staff {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.role-badge.user {\n  background: rgba(107, 114, 128, 0.1);\n  color: #6b7280;\n}\n\n/* Info Value */\n.info-value {\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  color: #333;\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n}\n\n\n/* Permissions Grid */\n.permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.permission-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 16px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  text-align: center;\n  transition: all 0.2s ease;\n}\n\n.permission-item:hover {\n  background: #e9ecef;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.permission-label {\n  font-weight: 600;\n  color: #333;\n  font-size: 0.9rem;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.permission-status {\n  font-weight: 700;\n  font-size: 1rem;\n  padding: 4px 8px;\n  border-radius: 6px;\n  min-width: 60px;\n}\n\n.permission-status.yes {\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.1);\n}\n\n.permission-status.no {\n  color: #e53e3e;\n  background: rgba(229, 62, 62, 0.1);\n}\n\n/* Modal Footer - Now using global styles from design-system.css */\n\n/* Buttons - Now using global styles from design-system.css */\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c82333;\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .form-row:first-child {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .user-name-only {\n    font-size: 1.6rem;\n  }\n\n  .permissions-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 12px;\n  }\n\n  .modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n  }\n\n  .form-section {\n    margin-bottom: 20px;\n  }\n\n  .user-profile-section {\n    padding: 16px;\n  }\n\n  .user-name-only {\n    font-size: 1.4rem;\n  }\n\n  .permissions-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .permission-item {\n    padding: 16px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
